var map = {
	"./01.jpg": 262,
	"./02.jpg": 263,
	"./03.jpg": 264,
	"./04.jpg": 265,
	"./05.jpg": 266,
	"./06.jpg": 267,
	"./07.jpg": 268,
	"./08.jpg": 269,
	"./09.jpg": 270,
	"./10.jpg": 271,
	"./11.jpg": 272,
	"./12.jpg": 273,
	"./13.jpg": 274,
	"./14.jpg": 275,
	"./15.jpg": 276,
	"./16.jpg": 277,
	"./17.jpg": 278,
	"./18.jpg": 279,
	"./19.jpg": 280,
	"./20.jpg": 281,
	"./21.jpg": 282,
	"./22.jpg": 283,
	"./23.jpg": 284,
	"./24.jpg": 285,
	"./25.jpg": 286,
	"./26.jpg": 287,
	"./27.jpg": 288,
	"./28.jpg": 289,
	"./29.jpg": 290,
	"./31.jpg": 291,
	"./32.jpg": 292,
	"./33.jpg": 293,
	"./34.jpg": 294,
	"./35.jpg": 295,
	"./36.jpg": 296,
	"./37.jpg": 297,
	"./38.jpg": 298,
	"./39.jpg": 299,
	"./40.jpg": 300,
	"./41.jpg": 301,
	"./42.jpg": 302,
	"./43.jpg": 303,
	"./44.jpg": 304,
	"./45.jpg": 305,
	"./46.jpg": 306,
	"./47.jpg": 307
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black nonrecursive \.(png|jpe?g|svg)$
// module id = 261
// module chunks = 0